export const SET_CLAIM = 'SET_CLAIM'
export const RESET_CLAIM = 'RESET_CLAIM'